import { IIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It renders a file tree icon with a folder shape.
 */
export function FileTrackerIcon({
  className,
  strokeWidth = 1.5,
  variant,
}: Readonly<IIconProps>) {
  if (variant !== 'solid') {
    return (
      <svg className={className} fill="none" viewBox="0 0 24 24">
        <path
          className="stroke-gray-800"
          d="M8 18H5a2 2 0 0 1-2-2V3M8 7H3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
        <path
          className="stroke-gray-800"
          clipRule="evenodd"
          d="M18.085 3H12.5A1.5 1.5 0 0 0 11 4.5v5a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 21 9.5V5.915a1.5 1.5 0 0 0-.44-1.06l-1.415-1.416A1.5 1.5 0 0 0 18.085 3ZM18.085 14H12.5a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5v-3.585a1.5 1.5 0 0 0-.44-1.06l-1.415-1.416a1.5 1.5 0 0 0-1.06-.439Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
      </svg>
    );
  }

  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        className="stroke-green-800"
        d="M8 18H5a2 2 0 0 1-2-2V3M8 7H3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        className="fill-green-800 stroke-green-800"
        clipRule="evenodd"
        d="M18.085 3H12.5A1.5 1.5 0 0 0 11 4.5v5a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 21 9.5V5.915a1.5 1.5 0 0 0-.44-1.06l-1.415-1.416A1.5 1.5 0 0 0 18.085 3Z"
        fillRule="evenodd"
        opacity={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        className="fill-green-800 stroke-green-800"
        clipRule="evenodd"
        d="M18.085 14H12.5a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5v-3.585a1.5 1.5 0 0 0-.44-1.06l-1.415-1.416a1.5 1.5 0 0 0-1.06-.439Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
